<template>
  <a-modal v-model="visible" title="催单反馈" @ok="handleOk" :width="600">
    <div style="color:#1890ff;font-weight:bold;" class="mb-10">订单号：{{ info.orderNo }}</div>
    <div v-for="(v, k) in result" :key="k">
      <div class="bold mb-10">企业备注：{{ k }}</div>
      <div v-if="v.length > 0">
        <div class="mtb-10">反馈结果：</div>
        <a-steps progress-dot current="null" direction="vertical">
          <a-step v-for="(item, i) in v" :key="i" :title="item.createTime" :description="item.content" />
        </a-steps>
      </div>
    </div>
    <a-form
      v-if="type == 1"
      style="margin-top:20px"
      :form="form"
      layout="inline"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 12 }"
    >
      <a-form-item label="反馈意见：" style="width:100%">
        <a-textarea
          style="width:100%"
          v-decorator="['content', { rules: [{ required: true, message: '请输入反馈意见' }] }]"
          placeholder="请输入反馈意见..."
          rows="5"
          allow-clear
        />
      </a-form-item>
      <a-form-item label="处理状态" style="width:100%">
        <a-radio-group v-decorator="['reminderStatus', { initialValue: '1' }]">
          <a-radio value="1">
            持续处理中
          </a-radio>
          <a-radio value="2">
            处理完成
          </a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { cuidanResult, cuidanFeedback } from '@/api/order/orderList'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  data() {
    return {
      visible: false,
      info: {},
      type: '', // 1 客服
      result: {},
      form: this.$form.createForm(this, { name: 'coordinated' })
    }
  },
  methods: {
    init(info, type) {
      this.type = type // 1 客服
      this.info = info
      this.visible = true
      console.log(info)
      cuidanResult({
        reminderId: info.id
      }).then(res => {
        this.result = res.data
      })
    },
    handleOk() {
      if (this.type == 1) {
        this.form.validateFields((err, values) => {
          if (!err) {
            cuidanFeedback(
              Object.assign(
                {
                  reminderId: this.info.id,
                  orderId: this.info.orderId
                },
                values
              )
            ).then(res => {
              if (res.code == 0) {
                this.$message.success('反馈成功')
                this.visible = false
                this.form.resetFields()
                this.$emit('update')
                this.$axios({
                  method: 'get',
                  url: '/api/order/reminder/reminderOrderCount',
                  headers: {
                    token: Vue.ls.get(ACCESS_TOKEN),
                    'Content-Type': 'application/json;charset=UTF-8'
                  }
                }).then(res => {
                  this.$store.commit('getCuidanCount', res.data.data)
                })
              }
            })
          }
        })
      } else {
        this.visible = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.ant-form-item-control-wrapper {
  width: 85%;
}
/deep/ .ant-steps-dot .ant-steps-item-content {
  width: 90%;
}
</style>
